import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant'

import router from './router'
import store from './store'
import 'lib-flexible'
import 'vant/lib/index.css'
import '../public/js/http.js'
import '../public/js/formatCheck.js'
Vue.config.productionTip = false

Vue.use(Vant)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
